import { useEffect, useState } from 'react';

const S = {
  page:    { padding:'28px 24px', maxWidth:1200, margin:'0 auto', fontFamily:'Poppins, sans-serif' },
  h1:      { fontSize:'1.6rem', fontWeight:800, color:'#1a1a2e', display:'flex', alignItems:'center', gap:10, margin:'0 0 24px' },
  cards:   { display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(220px, 1fr))', gap:16, marginBottom:32 },
  card:    { background:'#fff', borderRadius:16, boxShadow:'0 4px 20px rgba(0,0,0,0.07)', padding:'20px 24px' },
  cardNum: { fontSize:'2rem', fontWeight:800, color:'#1a2a4a' },
  cardLbl: { fontSize:'0.85rem', color:'#64748b', fontWeight:600, marginTop:4 },
  grid:    { display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(380px, 1fr))', gap:20 },
  panel:   { background:'#fff', borderRadius:16, boxShadow:'0 4px 20px rgba(0,0,0,0.07)', overflow:'hidden' },
  panelH:  { padding:'16px 20px', background:'#1a2a4a', color:'#fff', fontWeight:700, fontSize:'0.95rem', display:'flex', alignItems:'center', gap:8 },
  table:   { width:'100%', borderCollapse:'collapse' },
  th:      { padding:'10px 16px', textAlign:'left', background:'#f8fafc', color:'#64748b', fontWeight:700, fontSize:'0.75rem', textTransform:'uppercase', letterSpacing:'0.4px' },
  td:      { padding:'10px 16px', fontSize:'0.88rem', color:'#334155', borderTop:'1px solid #f1f5f9', verticalAlign:'middle' },
  periodBar: { display:'flex', flexWrap:'wrap', gap:8, marginBottom:24 },
  periodBtn: { border:'1.5px solid #e2e8f0', background:'#fff', color:'#475569', borderRadius:999, padding:'8px 18px', fontSize:'0.85rem', fontWeight:600, fontFamily:'Poppins, sans-serif', cursor:'pointer', transition:'all .15s' },
  periodBtnActive: { border:'1.5px solid #1e90ff', background:'#1e90ff', color:'#fff' },
  hint:    { fontSize:'0.78rem', color:'#94a3b8', fontWeight:500, marginTop:6 },
  barRows:  { padding:'14px 20px 18px', display:'flex', flexDirection:'column', gap:14 },
  barRow:   { display:'flex', alignItems:'center', gap:12 },
  barLabel: { width:170, flexShrink:0, fontSize:'0.85rem', color:'#334155', fontWeight:600, display:'flex', alignItems:'center', gap:8 },
  barTrack: { flex:1, height:10, background:'#f1f5f9', borderRadius:6, overflow:'hidden' },
  barFill:  { height:'100%', borderRadius:6, background:'linear-gradient(90deg, #1e90ff, #16c2fb)', transition:'width .3s ease' },
  barTotal: { width:36, textAlign:'right', flexShrink:0, fontSize:'0.85rem', fontWeight:800, color:'#1a2a4a' },
};

const PERIODS = [
  { key:'1d',  label:'Hoje' },
  { key:'7d',  label:'7 dias' },
  { key:'30d', label:'1 mês' },
  { key:'1y',  label:'1 ano' },
  { key:'all', label:'Tudo' },
];

const ACTIVITY_LABELS = {
  'jogo-pergunta':     'Jogos de Perguntas',
  'color-game':        'Jogos de Cores',
  'pratica':           'Treinar Seu Inglês',
  'dicionario-faminto':'Dicionário Faminto',
  'vocabulario':       'Vocabulário',
  'dialogos':          'Diálogos em Inglês',
  'pronuncia':         'Jogo de Pronúncia',
  'verbos':            'Verbos em Inglês',
  'phrasal-verbs':     'Phrasal Verbs',
  'falsos-cognatos':   'Falsos Cognatos',
  'idioms':            'Idioms em Inglês',
  'conversa-ia':       'Conversa com IA',
};

const ACTIVITY_ICONS = {
  'jogo-pergunta':     'fas fa-question-circle',
  'color-game':        'fas fa-palette',
  'pratica':           'fas fa-language',
  'dicionario-faminto':'fas fa-book-open',
  'vocabulario':       'fas fa-spell-check',
  'dialogos':          'fas fa-comments',
  'pronuncia':         'fas fa-microphone',
  'verbos':            'fas fa-book',
  'phrasal-verbs':     'fas fa-link',
  'falsos-cognatos':   'fas fa-exclamation-triangle',
  'idioms':            'fas fa-comment-dots',
  'conversa-ia':       'fas fa-robot',
};

function Card({ icon, num, label }) {
  return (
    <div style={S.card}>
      <div style={S.cardNum}><i className={icon} style={{ marginRight:10, color:'#1e90ff' }} />{num}</div>
      <div style={S.cardLbl}>{label}</div>
    </div>
  );
}

function RankingPanel({ icon, title, rows, columns, emptyMsg }) {
  return (
    <div style={S.panel}>
      <div style={S.panelH}><i className={icon} />{title}</div>
      {rows.length === 0 ? (
        <div style={{ padding:'28px 20px', textAlign:'center', color:'#94a3b8', fontSize:'0.88rem' }}>{emptyMsg}</div>
      ) : (
        <table style={S.table}>
          <thead>
            <tr>
              {columns.map(c => <th key={c.key} style={S.th}>{c.label}</th>)}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={i}>
                {columns.map(c => (
                  <td key={c.key} style={S.td}>{c.render ? c.render(row) : row[c.key]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

function ActivityBarsPanel({ rows, emptyMsg }) {
  const max = rows.reduce((m, r) => Math.max(m, r.total), 0) || 1;
  return (
    <div style={S.panel}>
      <div style={S.panelH}><i className="fas fa-gamepad" />Atividades mais acessadas no período</div>
      {rows.length === 0 ? (
        <div style={{ padding:'28px 20px', textAlign:'center', color:'#94a3b8', fontSize:'0.88rem' }}>{emptyMsg}</div>
      ) : (
        <div style={S.barRows}>
          {rows.map(row => (
            <div key={row.activity_key} style={S.barRow}>
              <div style={S.barLabel}>
                <i className={ACTIVITY_ICONS[row.activity_key] || 'fas fa-gamepad'} style={{ color:'#1e90ff', width:16 }} />
                {ACTIVITY_LABELS[row.activity_key] || row.activity_key}
              </div>
              <div style={S.barTrack}>
                <div style={{ ...S.barFill, width: `${(row.total / max) * 100}%` }} />
              </div>
              <div style={S.barTotal}>{row.total}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function AdminDashboard() {
  const [stats,   setStats]   = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState('');
  const [period,  setPeriod]  = useState('7d');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const res = await fetch(`/admin/dashboard-stats?period=${period}`, { credentials: 'include' });
        if (!res.ok) throw new Error('Erro ao carregar estatísticas.');
        const data = await res.json();
        if (!cancelled) setStats(data);
      } catch (e) {
        if (!cancelled) setError(e.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [period]);

  if (loading && !stats) {
    return (
      <div style={{ ...S.page, textAlign:'center', padding:'80px 0', color:'#94a3b8' }}>
        <i className="fas fa-spinner fa-spin fa-2x" />
      </div>
    );
  }

  if (error) {
    return <div style={{ ...S.page, textAlign:'center', color:'#dc2626' }}>{error}</div>;
  }

  return (
    <div style={S.page}>
      <h1 style={S.h1}>
        <i className="fas fa-chart-line" style={{ color:'#1e90ff' }} />
        Dashboard
        {loading && <i className="fas fa-spinner fa-spin" style={{ fontSize:'0.9rem', color:'#94a3b8', marginLeft:6 }} />}
      </h1>

      <div style={S.periodBar}>
        {PERIODS.map(p => (
          <button
            key={p.key}
            onClick={() => setPeriod(p.key)}
            style={{ ...S.periodBtn, ...(period === p.key ? S.periodBtnActive : {}) }}
          >
            {p.label}
          </button>
        ))}
      </div>

      <div style={S.cards}>
        <Card icon="fas fa-eye" num={stats.totalVisits} label="Visitas totais ao site" />
        <Card icon="fas fa-calendar-day" num={stats.periodVisits} label={`Visitas no período selecionado (${PERIODS.find(p => p.key === period)?.label.toLowerCase()})`} />
      </div>

      <div style={S.grid}>
        <RankingPanel
          icon="fas fa-newspaper"
          title="Matérias mais acessadas (total)"
          rows={stats.topViewedPosts}
          emptyMsg="Nenhuma visualização registrada ainda."
          columns={[
            { key:'title', label:'Matéria' },
            { key:'views', label:'Acessos' },
          ]}
        />
        <RankingPanel
          icon="fas fa-comments"
          title="Matérias mais comentadas no período"
          rows={stats.topCommentedPosts}
          emptyMsg="Nenhum comentário registrado nesse período."
          columns={[
            { key:'title', label:'Matéria' },
            { key:'total', label:'Comentários' },
          ]}
        />
        <RankingPanel
          icon="fas fa-heart"
          title="Matérias mais curtidas no período"
          rows={stats.topLikedPosts}
          emptyMsg="Nenhuma curtida registrada nesse período."
          columns={[
            { key:'title', label:'Matéria' },
            { key:'total', label:'Curtidas' },
          ]}
        />
        <ActivityBarsPanel
          rows={stats.topActivities}
          emptyMsg="Nenhum acesso a atividades registrado nesse período."
        />
      </div>
      <div style={S.hint}>
        * "Matérias mais acessadas" usa o contador total de visualizações de cada matéria, que não é registrado por data — por isso esse painel sempre mostra o total geral.
      </div>
    </div>
  );
}
